import {Component,ElementRef,Inject,OnDestroy,OnInit,PLATFORM_ID,ViewChild,} from "@angular/core";
import { Store, select } from "@ngrx/store";
import { ActivatedRoute, Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { UrlService } from "@app/services/url.service";
import { _seoContent } from "@app/marketplace/seo-content/utils";
import { Observable, Subscription, of } from "rxjs";
import * as actions from "../state/product-details/details-actions";
import * as detailsSelectors from '@app/marketplace/products/state/product-details/details-selectors';
import * as cartSelectors from '../state/shopping-cart/cart-selectors';
import * as locationSelectors from '@app/marketplace/locations/state/locations-selectors';
import * as contactSelectors from '../../checkout/state/contacts/contacts-selectors';
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { PushToCartComponent } from "@app/marketplace/shared/_components/push-cart.component";
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SelectLocationComponent} from '@app/marketplace/locations/select-location/select-location.component';
import {StorageService} from '@app/services/storage.service';
import {ContactsComponent} from '@app/marketplace/checkout/contacts/contacts.component';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { ViewTypeEnum } from '@app/marketplace/core/enum/viewTypeEnum';
import * as searchSelectors from '@app/marketplace/products/state/product-search/search-selectors';
import {ContactOutputInterface} from '@app/marketplace/checkout/_models/contact.model';
import * as contactsActions from '@app/marketplace/checkout/state/contacts/contacts-actions';
import * as relatedActions from '@app/marketplace/products/state/related-product/related-actions';

@Component({
  selector: "app-product-details",
  templateUrl: "./product-details.component.html",
  styleUrls: ["./product-details.component.css"],
})
export class ProductDetailsComponent extends PushToCartComponent implements OnInit, OnDestroy {
  @ViewChild("selectItems", { static: false })
  payload: any;
  data$ :Observable<any>;
  selectedShippingType$: Observable<any>;
  shipping$: Observable<any>;
  isLoading$ :Observable<any>;
  isLoadingPushToCart$ :Observable<any>;
  quantity$:Observable<number>;
  theme = {'min-width': '273px','min-height' : '151px',background: '#f1f1f1'};
  location$:Observable<any>;
  provider$: Observable<any>;
  protected _subscriptions: Subscription[] = [];
  title = 'Cubatel Market | Tu tienda de envíos a Cuba';
  description = '¡Somos el Amazon cubano! Descubre nuestras tiendas online para comprar en Cuba desde el exterior. Entregamos a domicilio en todas las provincias cubanas.';
  keywords = 'tiendas online para envíos a cuba, amazon cubano, amazon en cuba, tiendas de envíos a cuba, tienda de envíos a cuba, envío a cuba online, tiendas online con envío a cuba, compras online en cuba desde el exterior, tiendas online en cuba para comprar desde el exterior, tiendas de envíos a cuba online, tiendas virtuales en cuba para comprar desde el exterior, compras online para cuba desde el exterior, tiendas online para comprar en cuba desde el exterior, compras desde el exterior para cuba';
  product: any = {};
  selectedContact$: Observable<ContactOutputInterface>;
  @ViewChild('targetElement') targetElement: ElementRef;
  @ViewChild('targetAttrElement') targetAttrElement: ElementRef;
  constructor(
    private store: Store<any>,
    private modalService: NgbModal,
    private storageService: StorageService,
    private urlService: UrlService,
    private metaService: Meta,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    @Inject(DOCUMENT) document: Document,
    @Inject(PLATFORM_ID) private platformId
  ) {
     super(route,metaService,titleService,router);
     this.data$ = this.store.select(detailsSelectors.selectResponse);
     this.shipping$ = this.store.select(detailsSelectors.selectShippingType);
     this.isLoading$ = this.store.select(detailsSelectors.selectLoading);
     this.isLoadingPushToCart$ = this.store.select(cartSelectors.selectIsLoading);
     this.location$ = this.store.select(locationSelectors.selectLocation);
     this.quantity$ = this.store.select(detailsSelectors.selectQuantity);
     this.store.dispatch(actions.ResetQuantityAction());
     this.provider$ = this.store.select(searchSelectors.selectProvider);
     this.selectedContact$ = this.store.select(contactSelectors.selectDefaultContact);
    this.payload = {
      pageIndex: 1,
      pageSize: 5,
      pagingStrategy: 0,
    };
  }

  increaseQuantity = () => this.store.dispatch(actions.IncreaseQuantityAction());
  reduceQuantity = () => this.store.dispatch(actions.ReduceQuantityAction());

  cancelRequest = () => this.store.dispatch(actions.CancelProductDetailsRequestAction());
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      this.loadContacts();
    }
    this.store.dispatch(actions.LoadingProductDetailAction());
    this.store.dispatch(relatedActions.ResetRelatedProductsAction());
    //this.selectedContact$.subscribe(result => console.log(result));
    this.data$.subscribe((result: any) => {
      if (result && result.success && result.data) {
        let title = 'Cubatel Market';
        if (result.data?.name) {title += ` | ${result.data.name}`; }
        this.updateMetaTags(title, result.data.shortText);
      }
    });
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }
  getShakeAnimation() {
    return [
      { transform: 'translateX(0)' },
      { transform: 'translateX(5px)' },
      { transform: 'translateX(-5px)' },
      { transform: 'translateX(5px)' },
      { transform: 'translateX(0)' },
    ];
  }
  getShakeAnimationTiming() {
    return {
      duration: 300,
      iterations: 3,
    };
  }


  public async validateAttr() {
    const attibutes = await this.store.pipe(select(detailsSelectors.selectAttibutes),take(1)).toPromise();
    console.info(attibutes);
    return false;
  }
  public async pushToCart(product:any) {
    const attributes = await this.store.pipe(select(detailsSelectors.selectAttibutes),take(1)).toPromise();
    if(attributes.length>0) {
      const matched = attributes.find(p => p.valId.length==0);
      if(matched){
        this.targetAttrElement.nativeElement.animate(this.getShakeAnimation(), this.getShakeAnimationTiming());
        this.toastr.error(`${"Debe especificar"} ${matched.attrText?.toLowerCase()}`);
        return;
      }
    }
    const shipping = await this.store.pipe(select(detailsSelectors.selectShippingType),take(1)).toPromise();
    if(shipping==0 && product.provider>0){
      this.targetElement.nativeElement.animate(this.getShakeAnimation(), this.getShakeAnimationTiming());
      this.toastr.error("Debe especificar tipo de envío.");
      return;
    }

    if(product.availability<=0){
      this.toastr.error("Lo sentimos, no hay disponibilidad para este producto.");
      return;
    }

    //var itemImg = $(`#${product.code}>`).find('img').eq(0);
    product.shippingType=shipping;
    product.attributes= {};
    product.attributesToShow= attributes.map(p => `${p.attrText} (${p.valText})`).join('/');
    attributes.forEach(function(item){product.attributes[item.attrId] = item.valId})

    var itemImg = $(`.active`).find('img').eq(0);
    this.flyToElement($(itemImg),product,ViewTypeEnum.ProductDetails,this.store);
  }

  showActive(id: string,count) {
    var i = count;
    while (i>0) {i -= 1; $(`#previewImg${i}`).removeClass('fade show active'); }
    $(`#previewImg${id}`).addClass("fade show active");
  }
  selectLocation() {
    if (this.storageService.isAuthenticated()) {
      const modalRef = this.modalService.open(ContactsComponent, {size: 'lg'});
      modalRef.componentInstance.firstContact = true;
      modalRef.componentInstance.selectLocation = true;
      modalRef.result.finally(() => {});
      this.loadContacts();
    } else {
      const modalRef = this.modalService.open(SelectLocationComponent, {size: 'sm'});
      modalRef.result.finally(() => {});
    }
  }

  loadContacts = () => {
    const payload = {
      pageIndex: 1,
      pageSize: 10
    };
    this.store.dispatch(contactsActions.LoadingContacts({payload: payload}));
  };

  ngOnDestroy(): void { this._subscriptions.forEach(x => x.unsubscribe()); this.cancelRequest(); }
}
